// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"77cf78c1","453":"a263db3f","732":"303def70","977":"f6b3d2a5"}[chunkId] + ".chunk.js";
};